import React, { useState, useCallback } from 'react';
import DOMPurify from 'dompurify';
import { useAuth } from '../../AuthContext';
import { generatePDF } from '../utils/pdfDownloader';

const ReportViewer = ({ 
    reportContent, 
    reportData, 
    selectedReportType, 
    userName, 
    userProfile, 
    onNewReport 
}) => {
    const { user } = useAuth();
    const preferredLanguage = user?.preferred_language || 'ENGLISH';

    const [pdfLoading, setPdfLoading] = useState(false);
    const [pdfProgress, setPdfProgress] = useState(0);

    // Clean report content - Remove markdown code blocks
    const cleanReportContent = useCallback((content) => {
        if (!content) return '';

        // Remove opening ```
        let cleaned = content.replace(/^```(?:\w+)?\n?/, '');

        // Remove closing ```
        cleaned = cleaned.replace(/\n?```$/, '');

        // Remove any other code fences inside
        cleaned = cleaned.replace(/``` [\s\S]*?```/g, '');

        return cleaned.trim();
    }, []);

    const handleDownloadPDF = useCallback(async () => {
        setPdfLoading(true);
        setPdfProgress(0);

        const cleanedContent = cleanReportContent(reportContent);

        const result = await generatePDF({
            reportContent: cleanedContent,
            selectedReportType,
            reportData,
            userName,
            userProfile,
            authUser: user,
            onProgress: (progress) => setPdfProgress(Math.round(progress)) // ✅ ROUND PROGRESS
        });

        if (!result.success) {
            alert('Failed to generate PDF. Please try again or contact support.');
        }

        setPdfLoading(false);
        setPdfProgress(0);
    }, [reportContent, selectedReportType, reportData, userName, userProfile, user, cleanReportContent]);

    const sanitizedContent = DOMPurify.sanitize(cleanReportContent(reportContent));

    return (
        <div className="report-viewer-section">
            {/* {pdfLoading && (
                <div className="pdf-loading-overlay">
                    <div className="loading-spinner"></div>
                     <h2>Generating PDF...</h2>
                    <p>Processing your {selectedReportType?.name}...</p>
                     
                    <div className="progress-bar-container">
                        <div 
                            className="progress-bar-fill" 
                            style={{ width: `${pdfProgress}%`, backgroundColor: '#ffa500' }}
                        ></div>
                    </div>
                    <p className="progress-text">{pdfProgress}% Complete</p>
                </div>
            )} */}

            <div className="consultation-types">
                <div className="report-btn">
                    <div className="booking-info">
                        <h2 className="heading">
                            {selectedReportType?.name}
                        </h2>
                    </div>

                   <div className="report-action-buttons">
                        <button
                            className="book-call-btn"
                            onClick={handleDownloadPDF}
                            disabled={pdfLoading}
                            title="Download report as PDF with proper formatting"
                        >
                            {pdfLoading ? `Loading ${pdfProgress}%` : 'Download PDF'}
                        </button>
                    </div>
                </div>

                <div className="detail-row">
                    <span>Generated on:</span>
                    <span className="consult-duration">
                        {new Date(reportData?.generatedAt).toLocaleString('en-IN')}
                    </span>
                </div>
                <div className="detail-row">
                    <span>Credits Used:</span>
                    <span className="consult-price">{reportData?.creditsUsed || 0}</span>
                </div>
                {/* {reportData?.reportId && (
                    <div className="detail-row">
                        <span>Report ID:</span>
                        <span className="detail-value">{reportData.reportId}</span>
                    </div>
                )} */}
                {reportData?.cached && (
                    <div className="detail-row" style={{ color: '#4CAF50' }}>
                        <span>Status:</span>
                        <span>Loaded from history (no credits charged)</span>
                    </div>
                )}
            </div>

            {/* ✅ STYLED REPORT CONTENT */}
            <div className="consultation-types report-content-container">
                <div
                    className="report-content-html"
                    dangerouslySetInnerHTML={{ __html: sanitizedContent }}
                />
            </div>
        </div>
    );
};

export default ReportViewer;
